import { createFileRoute } from '@tanstack/react-router'
import { ApprovalListPage } from './-components/approval-list-page'

export const Route = createFileRoute('/mrgolisoda/more/day-end-approvals/')({
  component: ApprovalListPage,
})
